import { useEffect, useState, useRef } from 'react'
import { api } from '../services/api'
import { useAuth } from './use-auth'

const POLL_INTERVAL_MS = 30_000

const listeners = new Set<() => void>()

export function invalidateAccessionCount(): void {
  listeners.forEach((fn) => fn())
}

export function useAccessionCount(): number {
  const { user } = useAuth()
  const [count, setCount] = useState(0)
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null)
  const [tick, setTick] = useState(0)

  useEffect(() => {
    const notify = () => setTick((t) => t + 1)
    listeners.add(notify)
    return () => {
      listeners.delete(notify)
    }
  }, [])

  useEffect(() => {
    if (!user) return

    let cancelled = false

    function fetchCount() {
      api
        .get<{ counts: { submittedOrders: number } }>('/dashboard/summary')
        .then((res) => {
          if (!cancelled) setCount(res.data?.counts?.submittedOrders ?? 0)
        })
        .catch(() => {})
    }

    fetchCount()
    if (timerRef.current) clearInterval(timerRef.current)
    timerRef.current = setInterval(fetchCount, POLL_INTERVAL_MS)

    return () => {
      cancelled = true
      if (timerRef.current) clearInterval(timerRef.current)
    }
  }, [user, tick])

  return count
}
